/**
 * ML Shop by Brand — scroll carousel
 */
(function () {
  const ROOT_SELECTOR = '[data-ml-sbb]';

  const getSlideStep = (track) => {
    const slide = track.querySelector('[data-ml-sbb-slide]');
    if (!slide) return track.clientWidth;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  };

  const updateArrows = (root, track) => {
    const prev = root.querySelector('[data-ml-sbb-prev]');
    const next = root.querySelector('[data-ml-sbb-next]');
    const maxScroll = track.scrollWidth - track.clientWidth;
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= maxScroll - 1;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  };

  const initCarousel = (root) => {
    if (root.dataset.mlSbbLayout === 'grid' || root.classList.contains('ml-sbb--grid')) return;

    const track = root.querySelector('[data-ml-sbb-track]');
    if (!track) return;

    const scrollBySlide = (direction) => {
      track.scrollBy({
        left: getSlideStep(track) * direction,
        behavior: 'smooth',
      });
    };

    root.querySelector('[data-ml-sbb-prev]')?.addEventListener('click', () => scrollBySlide(-1));
    root.querySelector('[data-ml-sbb-next]')?.addEventListener('click', () => scrollBySlide(1));

    track.addEventListener('scroll', () => updateArrows(root, track), { passive: true });
    window.addEventListener('resize', () => updateArrows(root, track));

    updateArrows(root, track);
  };

  const boot = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(ROOT_SELECTOR);
    if (root) initCarousel(root);
  });
})();
